import BaseProxy from "../../base-proxy";

export default {
  getReceiptUsers: async (input = {}) => {
    let baseProxy = new BaseProxy();
    if (!input.authToken) {
      return {};
    }
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${input.companyId}/receipt-users`;
    let receiptUsers = await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
    return receiptUsers;
  },

  getReceiptUserById: async (input = {}) => {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/receipt-user/${input.receiptUserId}`;
    let receiptUser = await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
    return receiptUser;
  },

  updateReceiptUser: async (input = {}) => {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/receipt-user/${input.payload._id}/update`;
    let result = await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
    return result;
  },

  createReceiptUser: async (input = {}) => {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/receipt-user/create`;
    let receiptUser = await baseProxy.putAuthenticatedData(endpointUrl, input.authToken, input.payload);
    return receiptUser;
  },

  validateEmailInAddress: async (input = {}) => {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/receipt-user/validate/email-in-address`;
    let response = await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
    return response;
  },

  isAccountingDssAccessible: async (authToken, companyId, forceRefresh) => {
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/receipt-system/is-accounting-dss-accessible/${companyId}`;
    return await baseProxy.postAuthenticatedData(endpointUrl, authToken, { force_refresh: forceRefresh });
  }
};
